/* Renew25 LP — in-place ES/EN switch driven by the footer dropdown.
   The skin store has no Spanish locale, so we can't use Shopify's /es/. Instead we
   swap a small set of strings client-side and stay on the test domain (important for
   the Meta domain test). To MATCH live's /es/ page exactly, we translate only what
   live translates — the nav + footer link labels and "Add to bag" — using the
   official Spanish copy from the main store's /es/ renew page. Headings, value props,
   product taglines, and the disclaimer stay in English, just like live's Spanish page. */
(function () {
  var DICT = {
    // nav + footer link labels (official ES from main store /es/)
    'Shop All': 'Comprar todo',
    'Shop': 'Tienda',
    'About': 'Acerca de',
    'Our Story': 'Nuestra historia',
    'Reviews': 'Reseñas',
    'Contact Us': 'Contáctenos',
    'Create account': 'Crear cuenta',
    'Log in': 'Ingresar',
    'Naturally Derived': 'De origen natural',
    'Eye Care': 'Cuidado de Ojos',
    'Face Creams': 'Cremas Faciales',
    'Face Oils': 'Aceites Faciales',
    'Face Serums': 'Sérums Faciales',
    'The Minis Shop': 'La Tienda Mini',
    'Help Center': 'Centro de ayuda',
    'FAQ': 'Preguntas más frecuentes',
    'Track an Order': 'Seguimiento de un pedido',
    'Gift Cards': 'Tarjetas de regalo',
    'My Account': 'Mi cuenta',
    'Privacy': 'Privacidad',
    'Terms': 'Términos',
    'Add to bag': 'Agregar al carrito'
  };

  var COOKIE = 'nt_lang';
  function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(n, v) { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=2592000'; }
  function urlLang() { try { return new URLSearchParams(location.search).get('lang'); } catch (e) { return null; } }

  // Swap matching text nodes to Spanish (whitespace-preserving, idempotent).
  function swapEs(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      if (!t) continue;
      var key = t.trim();
      if (DICT[key] && key !== DICT[key]) {
        var lead = t.match(/^\s*/)[0], trail = t.match(/\s*$/)[0];
        n.nodeValue = lead + DICT[key] + trail;
      }
    }
  }

  function toggleUI(lang) {
    var en = document.querySelector('.nt-footer__lang-option[lang="en"]');
    var es = document.querySelector('.nt-footer__lang-option[lang="es"]');
    if (en && es) {
      en.classList.toggle('is-active', lang !== 'es');
      es.classList.toggle('is-active', lang === 'es');
      en.setAttribute('aria-current', lang !== 'es' ? 'true' : 'false');
      es.setAttribute('aria-current', lang === 'es' ? 'true' : 'false');
    }
    var label = document.querySelector('[data-nt-lang-toggle] span');
    if (label) label.textContent = lang === 'es' ? 'Español' : 'English';
  }

  // Sync cookie with any ?lang in the URL, then resolve the active language.
  var fromUrl = urlLang();
  if (fromUrl === 'es' || fromUrl === 'en') setCookie(COOKIE, fromUrl);
  var lang = fromUrl || getCookie(COOKIE) || 'en';

  function init() {
    if (lang === 'es') swapEs(document.body);
    toggleUI(lang);

    // Product cards hydrate after load (and reset on bfcache pageshow), replacing text
    // nodes — re-swap so "Add to bag" etc. stay translated.
    window.addEventListener('nt:products:hydrated', function () { if ((getCookie(COOKIE) || 'en') === 'es') swapEs(document.body); });
    window.addEventListener('pageshow', function () { if ((getCookie(COOKIE) || 'en') === 'es') swapEs(document.body); });

    // Footer dropdown options: switch in-place, no navigation off-domain.
    var esOpt = document.querySelector('.nt-footer__lang-option[lang="es"]');
    var enOpt = document.querySelector('.nt-footer__lang-option[lang="en"]');
    if (esOpt) esOpt.addEventListener('click', function (e) { e.preventDefault(); setCookie(COOKIE, 'es'); swapEs(document.body); toggleUI('es'); });
    if (enOpt) enOpt.addEventListener('click', function (e) { e.preventDefault(); setCookie(COOKIE, 'en'); location.reload(); }); // English is the default server render
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
